export const AI_AGENT_MGPT_LANGUAGES = {
  KOREAN: 'ko-KR',
  ENGLISH: 'en-US',
  SPANISH: 'es-ES',
} as const;

export const AI_AGENT_MGPT_SERVICE_CHANNELS = {
  SCAUTR: 'SCAUTR',
  PROGIX: 'PROGIX',
  PRODOQ: 'PRODOQ',
} as const;

export const AI_AGENT_MANUAL_UPLOAD_CHANNELS = {
  ALL: 'all',
  ADMIN: 'ADMIN',
  SCAUTR: 'SCAUTR',
  PRODOQ: 'PRO-DOQ',
} as const;

export const AI_AGENT_TASK_STATUSES = {
  ALL: 'all',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
} as const;

export type AiAgentMgptLanguage = (typeof AI_AGENT_MGPT_LANGUAGES)[keyof typeof AI_AGENT_MGPT_LANGUAGES];
export type AiAgentMgptServiceChannel = (typeof AI_AGENT_MGPT_SERVICE_CHANNELS)[keyof typeof AI_AGENT_MGPT_SERVICE_CHANNELS];
export type AiAgentManualUploadChannel = (typeof AI_AGENT_MANUAL_UPLOAD_CHANNELS)[keyof typeof AI_AGENT_MANUAL_UPLOAD_CHANNELS];
export type AiAgentTaskStatus = (typeof AI_AGENT_TASK_STATUSES)[keyof typeof AI_AGENT_TASK_STATUSES];

export const AI_AGENT_MGPT_LANGUAGE_LABELS: Record<AiAgentMgptLanguage, string> = {
  [AI_AGENT_MGPT_LANGUAGES.KOREAN]: '한국어',
  [AI_AGENT_MGPT_LANGUAGES.ENGLISH]: 'English',
  [AI_AGENT_MGPT_LANGUAGES.SPANISH]: 'Español',
};

export const AI_AGENT_MGPT_SERVICE_CHANNEL_LABELS: Record<AiAgentMgptServiceChannel, string> = {
  [AI_AGENT_MGPT_SERVICE_CHANNELS.SCAUTR]: 'SCAUTR',
  [AI_AGENT_MGPT_SERVICE_CHANNELS.PROGIX]: 'PROGIX',
  [AI_AGENT_MGPT_SERVICE_CHANNELS.PRODOQ]: 'PRO-DOQ',
};

export const AI_AGENT_MANUAL_UPLOAD_CHANNEL_LABELS: Record<AiAgentManualUploadChannel, string> = {
  [AI_AGENT_MANUAL_UPLOAD_CHANNELS.ALL]: '전체',
  [AI_AGENT_MANUAL_UPLOAD_CHANNELS.ADMIN]: 'ADMIN',
  [AI_AGENT_MANUAL_UPLOAD_CHANNELS.SCAUTR]: 'SCAUTR',
  [AI_AGENT_MANUAL_UPLOAD_CHANNELS.PRODOQ]: 'PRO-DOQ',
};

export const AI_AGENT_TASK_STATUS_LABELS: Record<AiAgentTaskStatus, string> = {
  [AI_AGENT_TASK_STATUSES.ALL]: '전체',
  [AI_AGENT_TASK_STATUSES.IN_PROGRESS]: '진행중',
  [AI_AGENT_TASK_STATUSES.COMPLETED]: '완료',
  [AI_AGENT_TASK_STATUSES.FAILED]: '실패',
};

export const mgptLanguageOptions = [
  {
    value: AI_AGENT_MGPT_LANGUAGES.KOREAN,
    label: AI_AGENT_MGPT_LANGUAGE_LABELS[AI_AGENT_MGPT_LANGUAGES.KOREAN],
  },
  {
    value: AI_AGENT_MGPT_LANGUAGES.ENGLISH,
    label: AI_AGENT_MGPT_LANGUAGE_LABELS[AI_AGENT_MGPT_LANGUAGES.ENGLISH],
  },
  {
    value: AI_AGENT_MGPT_LANGUAGES.SPANISH,
    label: AI_AGENT_MGPT_LANGUAGE_LABELS[AI_AGENT_MGPT_LANGUAGES.SPANISH],
  },
] as const;

export const mgptServiceChannelOptions = [
  {
    value: AI_AGENT_MGPT_SERVICE_CHANNELS.SCAUTR,
    label: AI_AGENT_MGPT_SERVICE_CHANNEL_LABELS[AI_AGENT_MGPT_SERVICE_CHANNELS.SCAUTR],
  },
  {
    value: AI_AGENT_MGPT_SERVICE_CHANNELS.PROGIX,
    label: AI_AGENT_MGPT_SERVICE_CHANNEL_LABELS[AI_AGENT_MGPT_SERVICE_CHANNELS.PROGIX],
  },
  {
    value: AI_AGENT_MGPT_SERVICE_CHANNELS.PRODOQ,
    label: AI_AGENT_MGPT_SERVICE_CHANNEL_LABELS[AI_AGENT_MGPT_SERVICE_CHANNELS.PRODOQ],
  },
] as const;

export const manualUploadChannelOptions = [
  {
    value: AI_AGENT_MANUAL_UPLOAD_CHANNELS.ALL,
    label: AI_AGENT_MANUAL_UPLOAD_CHANNEL_LABELS[AI_AGENT_MANUAL_UPLOAD_CHANNELS.ALL],
  },
  {
    value: AI_AGENT_MANUAL_UPLOAD_CHANNELS.ADMIN,
    label: AI_AGENT_MANUAL_UPLOAD_CHANNEL_LABELS[AI_AGENT_MANUAL_UPLOAD_CHANNELS.ADMIN],
  },
  {
    value: AI_AGENT_MANUAL_UPLOAD_CHANNELS.SCAUTR,
    label: AI_AGENT_MANUAL_UPLOAD_CHANNEL_LABELS[AI_AGENT_MANUAL_UPLOAD_CHANNELS.SCAUTR],
  },
  {
    value: AI_AGENT_MANUAL_UPLOAD_CHANNELS.PRODOQ,
    label: AI_AGENT_MANUAL_UPLOAD_CHANNEL_LABELS[AI_AGENT_MANUAL_UPLOAD_CHANNELS.PRODOQ],
  },
] as const;

export const taskStatusOptions = [
  {
    value: AI_AGENT_TASK_STATUSES.ALL,
    label: AI_AGENT_TASK_STATUS_LABELS[AI_AGENT_TASK_STATUSES.ALL],
  },
  {
    value: AI_AGENT_TASK_STATUSES.IN_PROGRESS,
    label: AI_AGENT_TASK_STATUS_LABELS[AI_AGENT_TASK_STATUSES.IN_PROGRESS],
  },
  {
    value: AI_AGENT_TASK_STATUSES.COMPLETED,
    label: AI_AGENT_TASK_STATUS_LABELS[AI_AGENT_TASK_STATUSES.COMPLETED],
  },
  {
    value: AI_AGENT_TASK_STATUSES.FAILED,
    label: AI_AGENT_TASK_STATUS_LABELS[AI_AGENT_TASK_STATUSES.FAILED],
  },
] as const;
